<div class="row ss-top-menu">
	<div class="col-xl-9 col-lg-9 col-md-9 col-sm-9 col-xs-9">
		<span class="ss-text-light">Dashboard <i class="rightArrow fa fa-angle-right"></i></span>
    	<span class="ss-text-dark">List of Projects</span> 
  	</div>
</div>

<div class="rk-ui-notification err" *ngIf="erroralert"  style="z-index: 10000;">
	<span id="notificationMessageText">{{errorMessage}}</span>
	<a class="close rk-linknotification" (click)="erroralert=false">×</a>
</div>
<div class="rk-ui-notification" *ngIf="successalert"  style="z-index: 10000;">
	<span id="notificationMessageText">{{successMessage}}</span>
	<a class="close rk-linknotification" (click)="successalert=false">×</a>
</div>

<div class="mt-4 container-set">
	<div class="row">
	    <div class="col-md-12">
	      <div class="tableDiv table-responsive"  *ngIf="projectList && projectList.length>0">
	        <table class="table">
	          <thead>
	            <tr>
	            	<th class="firstTh"></th>
	              <th class="text-center ">#</th>
	              <th>Name</th>
	              <th>Start Date</th>
	              <th>Status</th>
	              <th>Sub Status</th>
	              <th>Customer</th>
	              <th>Designer</th>
	              <th>Community Manager</th>
	              <th>Total Amount</th>
	              <th>Paid Amount</th>
	              <th class="lastTh">Pending Amount</th>
	            </tr>
	          </thead>
	          <tbody>
	            <tr *ngFor="let project of  projectList; let i=index; ">
	            	<td><i class="fa fa-dot-circle-o" style="color: green" *ngIf="project.payment_varified==true"></i><i class="fa fa-dot-circle-o" style="color: red" *ngIf="project.payment_varified==false"></i></td>
	            	<td class="text-center ">{{i+1}}</td>
              	<td class="capitalize addCursor" routerLink="/project/{{project.id}}/list-boqs" style="color: blue;">{{project.name}}</td>
              	<td class="">{{project.created_at | date:'dd/MMM/yyy h:mm a'}}</td>
              	<td class="capitalize">{{project.status | replaceChar}}</td>
              	<td class="capitalize minWidthForTd">{{project.sub_status | replaceChar}}</td>
              	<td class="">{{project.user.name}} - {{project.user.email}}</td>
              	<td class=" capitalize">{{project.designer.name}} - {{project.designer.email}}</td>
              	<td class=" capitalize">{{project.cm.name}} - {{project.cm.email}}</td>
              	<td class="minWidthForTd">
              		<i class="fa fa-inr mr-1"></i>
              		<span *ngIf="project.payment_details.total_amount">{{project.payment_details.total_amount}}</span>
              		<span *ngIf="!project.payment_details.total_amount">0</span>
              	</td>
              	<td class="minWidthForTd">
              		<i class="fa fa-inr mr-1"></i> 
              		<span *ngIf="project.payment_details.paid_amount">{{project.payment_details.paid_amount}}</span>
              		<span *ngIf="!project.payment_details.paid_amount">0</span>
              	</td>
              	<td class="minWidthForTd">
              		<i class="fa fa-inr mr-1"></i>
              		<span *ngIf="project.payment_details.balance">{{project.payment_details.balance}}</span>
              		<span *ngIf="!project.payment_details.balance">0</span>
              	</td>
	            </tr>
	          </tbody>
	        </table>
	      </div>
	       <div class="col-md-12 not-found " *ngIf="projectList && projectList.length == 0">
            <div class="boq-img">
              <img src="../../../assets/img/desktop.png" style="height: 250px;width: 300px">
            </div>
            <p class=" pb-4" style="font-size: 21px;text-align: center;color: dimgray">Nothing to show...</p> 
        </div>

	    </div>
	</div>
</div>


// WEBPACK FOOTER //
// /Users/shobhit/Documents/codes/arrivae-frontend/src/app/platform/finance/dashboard/dashboard.component.html